export default ({
  computed: {
    displayedPrice() {
      return this.variant.final_displayed_price;
    },
    strikedPrice() {
      if (parseFloat(this.variant.discount_price) < parseFloat(this.variant.group_price)) {
        return this.variant.catalog_displayed_price;
      }
      return null;
    },
  },
});
